import './subpage_viewer.less';

import $ from 'jquery';
import React, { Component, Fragment } from 'react';
import { findDOMNode, createPortal } from 'react-dom';
import autobind from 'class-autobind';

import throttle from 'lodash/throttle';

import SubpageWrapperForViewer from './subpage_wrapper_for_viewer_container.jsx';

import Header from '../header/header_container.jsx';
import LegacyHeader from '../header_legacy/header_container.jsx';
import Footer from '../footer/footer_container.jsx';
import SectionsWrapperForViewer from '../sections/sections_wrapper_for_viewer_container.jsx';
import Navigation from '../navigation/root_container.jsx';
import InPageSearchDisplay from '../in_page_search_display/in_page_search_display_container.jsx';
import InPageSearchOpener from '../in_page_search_display/in_page_search_opener.jsx';
import NeedsRefreshModal from '../needs_refresh/needs_refresh_modal_container.jsx';
import Overlay from '../content_overlay/overlay_container.jsx';
import SectionsRoot from '../sections/sections_root.jsx';
import ScrollIndicator from '../navigation/scroll_indicator_container.jsx';
import SkipLink from 'zoomforth_codesbane_viewer/component_lib/skip_link_container.jsx';

import ErrorBoundary from 'zoomforth_component_lib/error_boundary.jsx';
import { OpacityTransition } from 'zoomforth_component_lib/transitions.jsx';
import ScrollToTop from 'zoomforth_codesbane_viewer/viewer/navigation/scroll_to_top_container.jsx';

import ConsentModal from 'zoomforth_codesbane_viewer/viewer/consent/consent_modal_container.jsx';

import { FIXED_NAV_BREAKPOINT_WIDTH } from 'zoomforth_codesbane_viewer/lib/browser_sizing.js';

import { APP_CONTAINER_SELECTOR } from 'zoomforth_codesbane_viewer/const/dom_selectors.js';

import {
  ZOOM_MODE_ENABLED_EVENT,
  ZOOM_MODE_DISABLED_EVENT
} from 'zoomforth_codesbane_viewer/viewer/managers/subpage_resize_event_manager.jsx';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

class SubpageViewer_Base extends Component {
  constructor() {
    super();

    this.state = {
      displayFixedNav: false,
      isAnchorActiveById: {},
      isZoomModeEnabled: false
    };

    this.skipLinkContainer = $('.skip-link-container').get(0);

    autobind(this);
  }

  componentDidMount() {
    const {
      shouldRenderNavigation,
      useFixedNavLinks,
      onSubpageDisplayedTrack,
    } = this.props;

    if (shouldRenderNavigation && useFixedNavLinks) {
      // This settings is from theme so it never changes while this component is mounted
      this.setupFixedNavigation();
    }

    onSubpageDisplayedTrack();


    $(window).on(ZOOM_MODE_ENABLED_EVENT, ()=> {
      this.setState({ isZoomModeEnabled: true });
    });

    $(window).on(ZOOM_MODE_DISABLED_EVENT, ()=> {
      this.setState({ isZoomModeEnabled: false });
    });
  }

  componentDidUpdate(prevProps) {
    const { onSubpageDisplayedTrack } = this.props;

    if (prevProps.currentSubpage !== this.props.currentSubpage) {
      onSubpageDisplayedTrack();
    }
  }

  componentWillUnmount() {
    $(APP_CONTAINER_SELECTOR).off('scroll.grid');
    $(window).off(ZOOM_MODE_ENABLED_EVENT);
    $(window).off(ZOOM_MODE_DISABLED_EVENT);
  }

  setupFixedNavigation() {
    if (!this.props.shouldRenderNavigation) {
      return;
    }

    const navNode = findDOMNode(this.navRef);

    if (!navNode) {
      return;
    }

    const $nav = $(navNode);
    const navOffset = $nav.offset().top;

    // HACK! Binding outside of component
    const $appContainer = $(APP_CONTAINER_SELECTOR);
    $appContainer.on(
      'scroll.grid',
      throttle(() => {
        var containerOffset = $appContainer.scrollTop();
        const displayFixedNav = containerOffset > navOffset;

        if (displayFixedNav !== this.state.displayFixedNav) {
          this.setState({
            displayFixedNav: displayFixedNav,
          });
        }
      }, 20)
    );
  }

  render() {
    const {
      doesZoomAffectText,
      currentSubpage,
      sections,
      overlayAsset,
      overlayContent,
      shouldShowFooter,
      isFullPage,
      isInPageSearchDisplayed,
      isNeedsRefreshDisplayed,
      isInPageSearchEnabled,
      isMobile,
      isTextResizePrevented=false,
      defaultSectionFontSize,
      shouldRenderHeader,
      shouldRenderNavigation,
      shouldRenderFooter,
      onInPageSearchOpenerClick,
      shouldUseLegacyHeader,
    } = this.props;
    
    const {
      displayFixedNav,
      isAnchorActiveById,
      isZoomModeEnabled
    } = this.state;
    
    return (
      <Fragment>
        {
          // we use a portal in order to push this to the top of the `body`
          // where `.skip-link-container` exists. this ensures it's the first
          // tabbed element available in the DOM.
          createPortal(<SkipLink />, this.skipLinkContainer)
        }

        <SubpageWrapperForViewer
          key={currentSubpage.id} // Force componentMount / Unmount on subpage change
          isFullPage={isFullPage}
          currentSubpage={currentSubpage}
          onActiveAnchorLinksChange={(isAnchorActiveById) => {
            this.setState({ isAnchorActiveById });
          }}
        >
          {currentSubpage.isScrollToTopEnabled && (
            <ScrollToTop isMobile={isMobile} />
          )}

          {currentSubpage.isScrollIndicatorEnabled && (
            <ScrollIndicator
              isMobile={isMobile}
              subpageAnchors={[0, 0, 0]}
              isAnchorActiveById={isAnchorActiveById}
            />
          )}

          {shouldRenderHeader && shouldUseLegacyHeader ? (
            <LegacyHeader />
          ) : (
            <Header />
            
          )}

          {isInPageSearchEnabled && shouldUseLegacyHeader && (
            <InPageSearchOpener onClick={onInPageSearchOpenerClick} />
          )}
          {/* navigation display to be done conditionally */}
          {shouldRenderNavigation && shouldUseLegacyHeader && (
            <Navigation
              ref={(ref) => {
                this.navRef = ref;
              }}
              shouldPreventDropdowns={!!displayFixedNav}
            />
          )}

          <OpacityTransition speed='fast'>
            {shouldRenderNavigation && displayFixedNav && (
              <Navigation isFixed={true} />
            )}
          </OpacityTransition>

          <SectionsWrapperForViewer
            sections={sections}
            defaultSectionFontSize={defaultSectionFontSize}
            isMobile={isMobile}
            isFullPage={isFullPage}
            isTextResizePrevented={
              isTextResizePrevented ||
              isMobile ||
              (
                doesZoomAffectText &&
                isZoomModeEnabled
              )
            }
            sectionRenderer={({ section, sectionFontSize, onSectionRefReceive }) => (
              <SectionsRoot 
                key={section.id}
                subpage={currentSubpage}
                section={section}
                sectionFontSize={sectionFontSize}
                fixedHeight={section.fixedHeight}
                isMobile={isMobile}
                onSectionRefReceive={onSectionRefReceive}
              />
            )}
          />

          {shouldRenderFooter && shouldShowFooter && <Footer />}

          <div className='viewer-consent-wrapper'>
            <ConsentModal />
          </div>
        </SubpageWrapperForViewer>

        {overlayContent &&
          createPortal(
            <Overlay
              key={overlayContent.uuid}
              asset={overlayAsset}
              contentItem={overlayContent}
              currentSubpage={currentSubpage}
            />,
            window.document.body
          )}

        {isInPageSearchDisplayed &&
          createPortal(
            <ErrorBoundary>
              <InPageSearchDisplay key={'fulltext'} />
            </ErrorBoundary>,
            window.document.body
          )}

        {isNeedsRefreshDisplayed &&
          createPortal(
            <ErrorBoundary>
              <NeedsRefreshModal key='needsrefresh' />
            </ErrorBoundary>,
            window.document.body
          )}
      </Fragment>
    );
  }
}

// The viewer version 1 component doesn't need to do anything with the base itself.
const SubpageViewer_ViewerVersion1 = SubpageViewer_Base;

class SubpageViewer_ViewerVersion2 extends SubpageViewer_Base {
  constructor() {
    super();
  }

  setupFixedNavigation() {
    const navNode = findDOMNode(this.navRef);
    if (!navNode) {
      return;
    }
    const $nav = $(navNode);
    const navOffset = $nav.offset().top;

    // HACK! Binding outside of component
    const $appContainer = $(APP_CONTAINER_SELECTOR);

    $appContainer.on(
      'scroll.grid',
      throttle(() => {
        const windowWidth = $(window).width();

        // if the browser is sized at the mobile breakpoint then we don't want to
        // obfuscate content with the fixed nav. This can occur on a zoom event
        // as well.
        if (windowWidth <= FIXED_NAV_BREAKPOINT_WIDTH) {
          this.setState({
            displayFixedNav: false,
          });

          return;
        }

        var containerOffset = $appContainer.scrollTop();
        const displayFixedNav = containerOffset > navOffset;

        if (displayFixedNav !== this.state.displayFixedNav) {
          this.setState({
            displayFixedNav: displayFixedNav,
          });
        }
      }, 20)
    );
  }
}

const SubpageViewer = (props)=> (
  <SiteViewerVersionComponentSelector>
    <SubpageViewer_ViewerVersion1
      forSiteViewerVersion={1}
      { ...props }
      doesZoomAffectText={false}
    />

    <SubpageViewer_ViewerVersion2
      forSiteViewerVersion={2}
      { ...props }
      defaultSectionFontSize="120%"
      doesZoomAffectText={true}
    />
  </SiteViewerVersionComponentSelector>
);

export default SubpageViewer;
